import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { NotificationsService } from '../../services/notifications.service';
import { TOAST_CLASS } from '../../enums/notification/notification.enum';

/**
 * Facade that combines structured logging with user-facing toast notifications.
 * Logs events (info/warn/error) and shows corresponding toasts via NotificationsService.
 */
@Injectable({ 
  providedIn: 'root' 
})
export class ToastLoggingService {
  constructor(
    private logService: LogService, 
    private notificationService: NotificationsService
  ) {}

  success(key: string, userMsg: string, data?: any) {
    this.logService.event(key, data);
    this.notificationService.showToast({ message: userMsg, cssClass: TOAST_CLASS.SUCCESS });
  }

  warn(key: string, userMsg: string, data?: any) {
    this.logService.warn(key, userMsg, data);
    this.notificationService.showToast({ message: userMsg, cssClass: TOAST_CLASS.WARNING });
  }

  error(key: string, error: Error | string, userMsg: string, data?: any) {
    this.logService.error(key, error, data);
    this.notificationService.showToast({ message: userMsg, cssClass: TOAST_CLASS.DANGER });
  }
}
